import './card-author.scss';

export default () => {

};
